import { GridRowId, GridSelectionModel, GridSortModel, GridRowModel } from '@mui/x-data-grid-pro';
import Role from 'types/entities/Role';
import { SearchParams } from 'api/ResourceAPI';
import Order from 'types/entities/Order';
import { Month } from 'types/models/Months';
import { Quarters } from 'types/models/Quarters';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import User from 'types/entities/User';

export const ChangeBaseLineActions = {
  LOAD_ORDER: 'LOAD_ORDER',
  LOAD_ORDER_BL: 'LOAD_ORDER_BL',
  INJECT_WORKUNITS: 'INJECT_WORKUNITS',
  INJECT_MONTHS: 'INJECT_MONTHS',
  INJECT_QUARTERS: 'INJECT_QUARTERS',
  SORT_TOTALWORKUNIT: 'SORT_TOTALWORKUNIT',
  INJECT_TOTALWORKUNITS: 'INJECT_TOTALWORKUNITS',
  INJECT_FILTER_TOTALWORKUNITS: 'INJECT_FILTER_TOTALWORKUNITS',
  FILTER_TOTALWORKNUNIT_FLAG: 'FILTER_TOTALWORKNUNIT_FLAG',
  CHANGE_PAGE_SIZE: 'CHANGE_PAGE_SIZE',
  CHANGE_PAGE: 'CHANGE_PAGE',
  LOAD_CHANGEBASELINE_CUSTOMERS: 'LOAD_CHANGEBASELINE_CUSTOMERS',
  LOAD_DELIVERABLE_DM: 'LOAD_DELIVERABLE_DM',
  SELECT_BL_DELIVERABLES: 'SELECT_BL_DELIVERABLES',
  SELECT_BL_DELIVERABLES_LIST: 'SELECT_BL_DELIVERABLES_LIST',
  SELECT_BL_ALL_DELIVERABLES: 'SELECT_BL_ALL_DELIVERABLES',
  EXCLUDE_BL_DELIVERABLES_COUNT: 'EXCLUDE_BL_DELIVERABLES_COUNT',
  CLEAR_CHANGE_BASELINE_STATE: 'CLEAR_CHANGE_BASELINE_STATE',
  DISPLAY_FILTER_TAG: 'DISPLAY_FILTER_TAG',
  SINGLE_WORUNIT_FLAG: 'SINGLE_WORUNIT_FLAG',
  MULTIPLE_WORKUNIT_FLAG: 'MULTIPLE_WORKUNIT_FLAG',
  EDIT_ORDER_BASELINE: 'EDIT_ORDER_BASELINE',
} as const;

export const getbaseLineSourceOrderAction = (payload: Order) => ({
  type: ChangeBaseLineActions.LOAD_ORDER,
  payload,
});
export const getbaseLineOrderAction = (payload: Order | null) => ({
  type: ChangeBaseLineActions.LOAD_ORDER_BL,
  payload,
});

export const injectTotalWorkunitsBLAction = (payload: {
  datas: OrderWorkunit[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
}) => ({
  payload,
  type: ChangeBaseLineActions.INJECT_TOTALWORKUNITS,
});

export const injectFilterTotalWorkunitsBLAction = (payload: { datas: OrderWorkunit[] }) => ({
  payload,
  type: ChangeBaseLineActions.INJECT_FILTER_TOTALWORKUNITS,
});

export const filterTotalFlagAction = (payload: boolean) => ({
  type: ChangeBaseLineActions.FILTER_TOTALWORKNUNIT_FLAG,
  payload,
});

// export const injectWorkunitsBaseLineAction = (workunits: CatalogWorkunit[]) => ({
//   payload: { workunits },
//   type: ChangeBaseLineActions.INJECT_WORKUNITS,
// });

// export const injectMonthsAction = (months: Month[]) => ({
//   payload: { months },
//   type: ChangeBaseLineActions.INJECT_MONTHS,
// });

export const injectQuartersAction = (quarters: Quarters[]) => ({
  payload: { quarters },
  type: ChangeBaseLineActions.INJECT_QUARTERS,
});

export const sortChangebaseLineAction = (payload: GridSortModel) => ({
  type: ChangeBaseLineActions.SORT_TOTALWORKUNIT,
  payload,
});

export const changePageSizeAction = (payload: number) => ({
  type: ChangeBaseLineActions.CHANGE_PAGE_SIZE,
  payload,
});

export const changePageAction = (payload: number) => ({
  type: ChangeBaseLineActions.CHANGE_PAGE,
  payload,
});

export const loadCustomersAction = (payload: User[]) => ({
  type: ChangeBaseLineActions.LOAD_CHANGEBASELINE_CUSTOMERS,
  payload,
});

export const loadDeliveryManagersAction = (payload: User[]) => ({
  type: ChangeBaseLineActions.LOAD_DELIVERABLE_DM,
  payload,
});

export const selectBLDeliverablesAction = (payload: GridSelectionModel) => ({
  type: ChangeBaseLineActions.SELECT_BL_DELIVERABLES,
  payload,
});

export const selectBLDeliverablesListAction = (payload: any) => ({
  type: ChangeBaseLineActions.SELECT_BL_DELIVERABLES_LIST,
  payload,
});

export const selectAllBLDeliverablesAction = (payload: boolean) => ({
  type: ChangeBaseLineActions.SELECT_BL_ALL_DELIVERABLES,
  payload,
});

export const excludeBLDeliverablesAction = (payload: GridRowId[]) => ({
  type: ChangeBaseLineActions.EXCLUDE_BL_DELIVERABLES_COUNT,
  payload,
});

export const clearChangeBaseLineStateAction = () => ({
  type: ChangeBaseLineActions.CLEAR_CHANGE_BASELINE_STATE,
});

export const tagFilterBaseLineAction = (payload: any) => ({
  type: ChangeBaseLineActions.DISPLAY_FILTER_TAG,
  payload,
});
export const singleWorkunitSaveAction = (payload: any) => ({
  type: ChangeBaseLineActions.SINGLE_WORUNIT_FLAG,
  payload,
});
export const multipleWorkunitSaveAction = (payload: any) => ({
  type: ChangeBaseLineActions.MULTIPLE_WORKUNIT_FLAG,
  payload,
});
export const getbaseLineEditOrderAction = (payload: any) => ({
  type: ChangeBaseLineActions.EDIT_ORDER_BASELINE,
  payload,
});

export const changeBaseLineActions = {
  getbaseLineOrderAction,
  // injectWorkunitsBaseLineAction,
  // injectMonthsAction,
  filterTotalFlagAction,
  injectTotalWorkunitsBLAction,
  injectFilterTotalWorkunitsBLAction,
  injectQuartersAction,
  sortChangebaseLineAction,
  changePageSizeAction,
  loadCustomersAction,
  loadDeliveryManagersAction,
  selectAllBLDeliverablesAction,
  excludeBLDeliverablesAction,
  selectBLDeliverablesAction,
  selectBLDeliverablesListAction,
  clearChangeBaseLineStateAction,
  tagFilterBaseLineAction,
  singleWorkunitSaveAction,
  multipleWorkunitSaveAction,
  getbaseLineEditOrderAction,
};
